export class SmartphotoField {
    label;
    type;
    properties;
    value;
    required;
    options;
    placeholder;
    editable;
    custom;
    constructor(field, smartphoto, selectors) {
        this.label = field.labelContent ?? field.fieldDescription ?? '';
        this.type = field.dataType;
        this.properties = [field.fieldName];
        this.value = smartphoto[field.fieldName];
        this.options = (selectors ?? {})[field.listName ?? ''];
        this.placeholder = field.placeholder;
        this.required = field.mandatory;
        this.editable = field.editable;
        this.custom = field.custom;
        if (this.type === 'dateEpoch') {
            this.value = ((this.value || 0) * 1000);
        }
    }
}
